export interface FormatNameOptions {
  prefixName?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  suffixName?: string | null;
  showLastNameInitialOnly?: boolean;
  showMiddleName?: boolean;
}

export function formatName({
  prefixName,
  firstName,
  middleName,
  lastName,
  suffixName,
  showLastNameInitialOnly = false,
  showMiddleName = true,
}: FormatNameOptions): string {
  const formattedLastName =
    showLastNameInitialOnly && lastName?.trim() ? `${lastName.trim()[0]}.` : lastName;

  return [
    prefixName,
    firstName,
    showMiddleName ? middleName : undefined,
    formattedLastName,
    suffixName,
  ]
    .map((part) => part?.trim())
    .filter((part): part is string => Boolean(part))
    .join(' ');
}
